<h4 mat-dialog-title>
</h4>

<mat-dialog-content>
    <add-customer-action [customerActionId]="data.customerActionId"
                         [customerId]="data.customerId"
                         [customerAction]="data.customerAction"
                         [opportunityId]="data.opportunityId"
                         (actionSaved)="customerActionSaved($event)">Loading</add-customer-action>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="epi-button" (click)="cancel()" style="float: right">Close</button>
</mat-dialog-actions>
